import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=4dc83aeb&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=4dc83aeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc83aeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc83aeb')) {
      api.createRecord('4dc83aeb', component.options)
    } else {
      api.reload('4dc83aeb', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=4dc83aeb&scoped=true&", function () {
      api.rerender('4dc83aeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Y3EaIWyx9STN/JS/teamMember.vue"
export default component.exports